module.exports = __webpack_public_path__ + "img/search-w.9ce38e19.gif";